import React from 'react';
import { FormattedMessage } from 'react-intl';
import { get } from 'lodash';
import { CustomFileUploadField } from '../../components';

function FileUploadForm({ assistanceReqConfigs, onFileSelect, onFileRemove, language, fileStatuses }) {
  const collected_attributes = get(
    assistanceReqConfigs,
    "data.data[0].attributes.collected_attributes"
  );

  if (!collected_attributes?.file_upload) {
    return null;
  }

  return (
    <>
      <h3 className="mb-2 uploads ui-h3-heavy">
        <FormattedMessage
          id="kRug4Q"
          description="upload_documents"
          defaultMessage="Upload Documents"
        />
      </h3>
      <div className="mb-4 form-group">
        <CustomFileUploadField
          name="file_upload"
          id="uu_file_upload"
          multiple={true}
          onFileSelect={onFileSelect}
          onFileRemove={onFileRemove}
          language={language}
          fileStatuses={fileStatuses}
        />
      </div>
    </>
  );
}

export default FileUploadForm;
